import { defineResource } from 'pulse/resources';
import { defaultAppSettingsResolver } from './resolver';
export const AppSettingsEntity = defineResource({
  typeName: 'hs-resources:AppSettings',
  resolver: defaultAppSettingsResolver,
  args: ['appSettingName']
}).register();